export function isString(t:any):boolean{
    return typeof t=='string' || t instanceof String;
}


export function isNumber(t:any):boolean{
    return typeof t=='number' || t instanceof Number;
}
export function isBoolean(t:any):boolean{
    return typeof t=='boolean' || t instanceof Boolean;
}
export function getAsBoolean(t:boolean|string|any) : boolean{
    if(isBoolean(t)){
        return t;
    }else if(isString(t)){
        return t.toLowerCase()=='true'?true:false;
    }else{
        return false;
    }
}

function fixNumbers(str)
{
    let persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g],
    arabicNumbers  = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];
    if(typeof str === 'string')
    {
        for(var i=0; i<10; i++)
        {
            str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
        }
    }
  return str;
};
export function getAsNumber(t:number|string|any,nanIsZero:boolean=false){
    if(isString(t)){
        let r = Number.parseFloat(fixNumbers(t)); 
        if(isNaN(r)){
            if(nanIsZero){
                return 0;
            }
            return t;
        }
        return r;
    }else if(isNumber(t)){
        return t;
    }else{
        return t;
    }
}

function b64toBlob(b64Data, contentType='', sliceSize=512)
{
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
    
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);
    
        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }
    
        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }
    
    const blob = new Blob(byteArrays, {type: contentType});
    return blob;
}

export function downloadFile(b64content:string,filename:string){
    const blob = b64toBlob(b64content); 
    let nav = <any>navigator;
    if (nav.msSaveBlob) {
        nav.msSaveBlob(blob, filename);
    } else {
        const link = document.createElement('a');
        if (link.download !== undefined) {
            const url = URL.createObjectURL(blob);
            link.setAttribute('href', url);
            link.setAttribute('download', filename);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        }
    }
}

export function exportToCsv(filename: string, rows: object[]) {
    if (!rows || !rows.length) {
        return;
    }
    const separator = ',';
    const keys = Object.keys(rows[0]);
    var BOM = "\uFEFF"; 
    const csvData =BOM + 
    keys.join(separator) +
        '\n' +
        rows.map(row => {
            return keys.map(k => {
            let cell = row[k] === null || row[k] === undefined ? '' : row[k];
            cell = cell instanceof Date
                ? cell.toLocaleString()
                : cell.toString().replace(/"/g, '""');
            if (cell.search(/("|,|\n)/g) >= 0) {
                cell = `"${cell}"`;
            }
            return cell;
            }).join(separator);
        }).join('\n');
    const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
    let nav = <any>navigator;
    if (nav.msSaveBlob) { // IE 10+
        nav.msSaveBlob(blob, filename);
    } else {
        const link = document.createElement('a');
        if (link.download !== undefined) {
            // Browsers that support HTML5 download attribute
            const url = URL.createObjectURL(blob);
            link.setAttribute('href', url);
            link.setAttribute('download', filename);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }
}